/**
* timeline JS
* -----------------------------------------------------------------------------
*
* All the JS for the timeline component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'timeline',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.timeline' ).each( function( key, val ) {
        const progressBar = $( this ).find( '.progress-bar' )[0];
        const progress = $( this ).find( '.progress-bar .progress' )[0];
        const circles = $( this ).find( '.odd, .even' );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: progressBar,
            start: 'top 50%',
            end: 'bottom 50%',
            scrub: 0,
            // markers: true,
          },
        } );
        tl.to( progress, {scaleY: '1', ease: 'linear'}, 0 );

        $( circles ).each( function( rowKey, rowVal ) {
          const rowTl = gsap.timeline( {
            scrollTrigger: {
              trigger: rowVal,
              start: 'top 50%',
              end: 'bottom 50%',
              scrub: 0,
              onEnter: ( x, y, z ) => {
                $( rowVal ).addClass( 'is-passed' );
              },
              onLeaveBack: ( x, y, z ) => {
                $( rowVal ).removeClass( 'is-passed' );
              },
            },
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'timeline', COMPONENT );
} )( app );
